module.exports = __webpack_public_path__ + "static/media/spirit.2e9bb511.jpg";